import { createMuiTheme } from "@material-ui/core";
import { PRESENTAION_ELEMENT_ID } from "Components/Modal/Modal";
import {
	ToggleButtonGroupClassKey,
	ToggleButtonClassKey,
} from "@material-ui/lab";

export enum color {
	pageBackground = "#F3F1F1",
	primary = "#FF6022",
	secondary = "#807A77",
	totalBackground = "#FFF",
	tableHeadBackground = "#E9E8E8",
	tableCellBorder = "#D0D5D9",
	toggleBackground = "#EAE7E6",
	lightText = "#85746E",
	text = "#34180E",
}

export enum px {
	none = "0",
	px = "1px",
	xxs = "2px",
	xs = "4px",
	s = "8px",
	m = "12px",
	l = "16px",
	xl = "20px",
	xxl = "32px",
	xxxl = "48px",
}

declare module "@material-ui/core/styles/overrides" {
	export interface ComponentNameToClassKey {
		MuiToggleButtonGroup: ToggleButtonGroupClassKey;
		MuiToggleButton: ToggleButtonClassKey;
	}
}

export function useMuiTheme(shadowRoot: ShadowRoot) {
	return createMuiTheme({
		typography: {
			fontFamily: "Montserrat",
		},
		palette: {
			primary: {
				main: color.primary,
			},
			secondary: {
				main: color.secondary,
			},
			text: {
				primary: color.text,
			},
		},
		overrides: {
			MuiPaper: {
				rounded: {
					borderRadius: px.s,
				},
			},
			MuiButton: {
				contained: {
					boxShadow: "none",
				},
			},
			MuiSelect: {
				root: {
					display: "flex",
					alignItems: "center",
				},
			},
			MuiToggleButtonGroup: {
				root: {
					backgroundColor: color.toggleBackground,
					height: "28px",
					padding: "3px",
					borderRadius: "6px",
				},
				groupedHorizontal: {
					"&:not(:first-child)": {
						marginLeft: px.none,
						borderLeft: "0 none",
						borderTopLeftRadius: px.xs,
						borderBottomLeftRadius: px.xs,
					},
					"&:not(:last-child)": {
						borderTopRightRadius: px.xs,
						borderBottomRightRadius: px.xs,
					},
				},
			},
			MuiToggleButton: {
				root: {
					textTransform: "none",
					border: "0 none",
					padding: px.none,
					"&:hover": {
						backgroundColor: color.toggleBackground,
					},
					"&$selected": {
						backgroundColor: color.totalBackground,
						"&:hover": {
							backgroundColor: color.totalBackground,
						},
						"& > span": {
							fontWeight: "bold",
							margin: `${px.none} ${px.m}`,
						},
					},
					"& > .MuiTouchRipple-root": {
						display: "none",
					},
				},
				label: {
					color: color.text,
					fontSize: "12px",
					fontWeight: "normal",
					margin: `${px.none} ${px.xl}`,
				},
			},
			MuiList: {
				padding: {
					paddingTop: 0,
					paddingBottom: 0,
				},
			},
			MuiListSubheader: {
				sticky: {
					backgroundColor: color.pageBackground,
					height: 30,
					display: "flex",
					alignItems: "center",
					userSelect: "none",
					touchCallout: "none",
				},
			},
			MuiDialogContent: {
				root: {
					padding: `${px.s} ${px.l} ${px.l} ${px.l}`,
				},
			},
			MuiDialogTitle: {
				root: {
					padding: `${px.s} ${px.l}`,
				},
			},
		},
		props: {
			MuiDialog: {
				container: () => shadowRoot.getElementById(PRESENTAION_ELEMENT_ID),
			},
			MuiPopover: {
				container: () => shadowRoot.getElementById(PRESENTAION_ELEMENT_ID),
			},
			MuiTooltip: {
				PopperProps: {
					container: () => shadowRoot.getElementById(PRESENTAION_ELEMENT_ID),
					disablePortal: true,
				},
			}
		},
	});
}
